import Big from 'big.js'
import { WithInitialValue } from 'components/widgets/invest-component/interfaces/common'
import { CurrencyMetadata } from 'indices-list'
import { PrimitiveAtom } from 'jotai'
import { atomsWithQuery } from 'jotai-tanstack-query'
import { Address } from 'viem'

type QueryBalanceReturn = ReturnType<typeof atomsWithQuery<Big>>
export type QueryBalanceRequest = QueryBalanceReturn['0']
export type QueryBalanceDispatch = QueryBalanceReturn['1']

export type PriceRequestAtoms = {
  userAddress: PrimitiveAtom<Address> & WithInitialValue<Address>
  currentAsset: PrimitiveAtom<CurrencyMetadata> & WithInitialValue<CurrencyMetadata>
  response: QueryBalanceRequest
  dispatch: QueryBalanceDispatch
}

export const emptyBalance = Big(0)
